import React, { useState, useEffect } from 'react';

import { t } from 'i18next';
import { Text, Spinner } from '@datanomik/core-ui';

export const LoadingLayout = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + (Math.random() * 5 + 5);
        return (newProgress > 100) ? 100 : newProgress;
      });
    }, 180);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="relative h-[100vh] w-[100vw] bg-[#fff] dark:bg-[#0A0D14] flex items-center justify-center flex-col gap-[15px]">
      <div>
        <div className="relative inline-flex">
          <Spinner value={progress} size={64} tone="primary" />
          <div className="top-0 left-0 bottom-0 right-0 absolute flex items-center justify-center">
            <Text weight="bold" tone="default">
              {`${Math.round(progress)}%`}
            </Text>
          </div>

        </div>
      </div>

      <Text tone="default">
        {t('Loading information')}
      </Text>

    </div>
  );
};
